var render = function render(){var _vm=this,_c=_vm._self._c;return _c('action-view',_vm._g({staticClass:"swap-button"},_vm.$listeners),[_c('img',{attrs:{"src":require('@/assets/icons/swap.svg'),"width":"16","height":"16","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }